/**
 * Stores that hold state about estate agents (Access & Protection) register
 * here to reset with the estate. A leaf module with no imports, so a dependent
 * store can register at construction time without touching the estate store
 * itself - which may still be initializing inside an import cycle.
 */
const listeners = new Set<() => void>();

export const onEstateReset = (listener: () => void): void => {
  listeners.add(listener);
};

export const notifyEstateReset = (): void => {
  listeners.forEach(listener => listener());
};
